export default "/images/adherence_background.webp"